import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});
export const styles = StyleSheet.create({
  exhibitionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 22,
    paddingLeft: 53,
    paddingRight: 53,
    width: '100%',
  },
  exhibitionItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    width: '100%',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 15,
    alignItems: 'center',
    width: '100%',
  },
  imageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    border: '2px solid #EEEEEE',
    borderRadius: '5px',

    width: 110,
    height: 60,
  },
  titleWrapper: {
    flex: 1,
    justifyContent: 'center',
  },
  logo: {
    maxWidth: 82,
    width: 'auto',
    maxHeight: 40,
    height: 'auto',
    objectFit: 'cover',
  },
  aboutText: {
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 300,
  },
});
